import { Box, styled } from "@mui/material";

export const SideComponentWrapper = styled(Box)(({ theme }) => ({
  width: "100dvh",
  height: "64px",
  position: "fixed",
  background: "transparent",
  transformOrigin: "left top",
  zIndex: 1,
  transform: "rotate(-90deg) translate(-100%, 0)",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    width: "100dvh",
  },
}));

interface SideComponentChildProps {
  showBorder?: boolean;
}

export const SideComponentChild = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'showBorder'
})<SideComponentChildProps>(({ theme, showBorder = true }) => ({
  display: "flex",
  flexDirection: "row-reverse",
  justifyContent: "space-evenly",
  "& *": {
    fontSize: "20px",
    fontWeight: 500,
    flexGrow: 1,
    textAlign: "center",
    borderRight: showBorder ? "1px solid" : "none",  // Conditional border
    float: "right",
    transform: "rotate(180deg)",
    height: "100%",
    lineHeight: "64px",
  },
  "& .active": {
    background: theme.palette.primary.main,
    color: "#fff",
    cursor: "pointer",
  },
}));